import request from '@/utils/request'

const http = request()

export const addActivity = params => http.post('/activity/add', params)

export const updateActivity = params => http.post('/activity/update', params)

export const copyActivity = params => http.post('/activity/copy', params)

export const deleteActivity = params => http.post('/activity/delete', params)

export const updateActivityStatus = params => http.post('/activity/update-status', params)

export const activityPage = params => http.post('/activity/page', params)

export const activityExport = params => http.blob('/activity/export', params)

export const activityMaxId = params => http.post('/activity/maxid', params)

export const activityWxConfig = params => http.post('/activity/wx/config', params)

export const activityInstanceExport = params => http.blob('/activity/instance/export', params)

export const activityDetail = params => http.post('/activity/detail', params)

export const survey = params => http.post('/activity/survey', params)

export const saveActivityInstance = params => http.post('/activity-instance/save', params)

export const updateActivityInstance = params => http.post('/activity-instance/update', params)

export const removeActivityInstance = params => http.post('/activity-instance/remove', params)

export const activityInstancePage = params => http.post('/activity-instance/page', params)

export const activityInstanceDetail = params => http.post('/activity-instance/detail', params)

export const activityInstanceFiles = params => http.post('/activity-instance/files', params)

export const removeFile = params => http.post('/activity/file/remove', params)

export const allProjects = params => http.post('/activity/all-projects', params)

export const activityTypeAdd = params => http.post('/activity-type/add', params)

export const activityTypeDelete = params => http.post('/activity-type/delete', params)

export const activityTypeList = params => http.post('/activity-type/list', params)
